import React from "react";
import { FormComponent } from "../../../components/form/DynamicForm";
import BuscarFactura from "../../../components/BuscarFactura";
import { Form, Validators } from "../../../components/form/DynamicFormTs";
import { withRouter } from "react-router-dom";
import Http from "../../../Http";
import { objectAsParams } from "../../../helpers";
import FacturaClienteFacturas from "./FacturaClienteFacturas";
import { Button } from "@material-ui/core";

class FacturaCliente extends FormComponent {
  componentDidMount() {
    let buttons = ["Guardar Cliente"];
    if (this.props.match.params.id) {
      buttons = [];
    }
    this.FormConfig(
      {
        defaultUrl: "factura-cliente/one",
        saveUrl: "factura-cliente/save",
        backUrl: "/Cobranza/FacturasClientes",
      },
      new Form(
        [
          Form.Field("autocomplete", "id_cliente", "Buscar un Cliente", "", [Validators.required], 12, [], [], [], false, buttons.length === 0),
        ],
        buttons,
        "Folio Cliente"
      ),
      this.formData
    );
    if (this.props.match.params.id) {
      this.LoadPreds();
    }
    this.setState({ facturas: [], add: false });
  }

  LoadPreds = async (predId = null, callOnChange = true) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`factura-cliente/one/${id}`);
    if (!Res.error) {
      this.formCliId = Res.data.id_cliente;
      this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, callOnChange), });
      this.setState({ FormData: await this.formData() });
    }
    return Res.data;
  };

  formData = async (form) => {
    if (!form) form = this.state.FormData;
    const params = {};
    let newForm = form;
    if (this.formCliente) {
      params["cli"] = this.formCliente;
      this.formCliente = null;
    }
    if (this.formCliId) {
      params["c"] = this.formCliId;
    }

    const Res = await Http.get(`nota-credito/form?${objectAsParams(params)}`);
    if (!Res.error) {
      const { clientes } = Res.data;
      if (clientes) {
        newForm = Form.FieldOptions(
          newForm,
          "id_cliente",
          clientes,
          "id",
          "cliente_rsocial"
        );
      }
    }
    newForm = Form.ValueChange(newForm, {
      id_cliente: this.clienteChange,
    });

    return newForm;
  };

  clienteChange = async (form, field) => {
    this.formCliente = field.ValueAt;
    return this.formData(form);
  };

  onAdddFactura = (factura) => {
    this.setState((state) => {
      if (state.facturas.some((sfactura) => sfactura.id === factura.id)) {
        state.sbOpen = true;
        state.sbMsg = "La factura ya fue seleccionada";
      } else {
        factura.nueva = true;
        state.facturas = [factura, ...state.facturas];
        state.add = true;
      }
      return state;
    });
  };

  onSaveFacturas = async () => {
    const id = this.props.match.params.id;
    const id_cliente = this.formCliId;
    const { facturas } = this.state;

    this.setState({ loading: true });
    const Res = await Http.post(`${this.config.saveUrl}`, { id, id_cliente, facturas });

    if (!Res.error) {
      this.setState({ loading: false, sbMsg: "Guardado", sbOpen: true });
      if (this.props.back) {
        this.props.history.push(`${this.config.backUrl}`);
      }
    } else {
      this.setState({
        loading: false,
        sbMsg: `Error al guardar${Res.errMsg ? `: ${Res.errMsg}` : ""}`,
        sbOpen: true,
      });
    }
  };

  onDelete = (fac) => {
    console.log('on delete', fac);
    const { facturas } = this.state;
    let newFacturas = facturas.filter(f => f.id !== fac.id);
    console.log(newFacturas);
    this.setState({
      facturas: newFacturas,
      add: true,
    })
  }

  onDownloadReporte = async (i, vals) => {
    this.setState({ loading: true });
    const id = this.props.match.params.id;
    const Resp = await Http.get(`factura-cliente/reporte-guia-acuses?id=${id}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `reporte_guias_escaneadas_${id}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loading: false });
  }

  downloadFiles = async (idArchivo = []) => {
    const id = this.props.match.params.id;
    this.setState({ loading: true });
    const Resp = await Http.get(`factura-cliente/download?id=${id}`, true, "arraybuffer");
    if (!Resp.error) {
      let blob = new Blob([Resp], { type: "application/zip" });
      let filename = `${id}.zip`;
      const pdfURL = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = pdfURL;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(pdfURL);
    }
  };

  formChange = async (form, field) => {
    let newForm = { ...form };
    if (field.Name === 'id_cliente') {
      newForm = await this.clienteChange(form, field);
    }
    this.setState({ FormData: newForm }) 
  }

  render() {
    const { match } = this.props;
    const { facturas, add, loading } = this.state;
    return (
      <div>
        <this.FormRender />
        {match.params.id ? (
          <div>
            <BuscarFactura
              idCliente={this.formCliId}
              onSelect={this.onAdddFactura}
            />
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: '5px' }}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={this.onDownloadReporte}
                disabled={loading}
              >
                Reporte Acuses Guias Escaneadas
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={this.downloadFiles}
                disabled={loading}
                style={{ display: "flex", justifyContent: "flex-end", margin: '0px 5px' }}
              >
                Descargar Todos los Acuses
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={this.onSaveFacturas}
                disabled={loading}
              >
                Guardar
              </Button>
            </div>
            <FacturaClienteFacturas
              idFolio={match.params.id}
              facturas={facturas}
              add={add}
              onAdd={() => {
                this.setState({ add: false });
              }}
              onDelete={this.onDelete}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default withRouter(FacturaCliente);
